var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.23 30.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.12,0C6.78,0,0,6.78,0,15.12s6.78,15.12,15.12,15.12,15.12-6.78,15.12-15.12S23.45,0,15.12,0Zm0,28.63c-7.45,0-13.52-6.06-13.52-13.52S7.66,1.6,15.12,1.6s13.52,6.06,13.52,13.52-6.06,13.52-13.52,13.52Zm0-22.32c-3.71,0-6.73,2.99-6.73,6.67,0,1.61.75,3.66,2.25,6.1.74,1.21,1.67,2.53,2.83,4.03.4.51,1,.81,1.65.81s1.25-.29,1.65-.81c1.16-1.49,2.09-2.81,2.83-4.03,1.49-2.44,2.24-4.49,2.24-6.1,0-3.68-3.02-6.67-6.73-6.67Zm3.12,11.93c-.71,1.16-1.6,2.43-2.73,3.88-.13.17-.3.19-.39.19s-.26-.02-.39-.19c-1.13-1.45-2.02-2.71-2.73-3.88-1.32-2.15-2.01-3.97-2.01-5.26,0-2.8,2.3-5.07,5.13-5.07s5.13,2.28,5.13,5.07c0,1.29-.7,3.11-2.01,5.26Zm-3.12-8.42c-1.78,0-3.22,1.44-3.22,3.22s1.44,3.22,3.22,3.22,3.22-1.44,3.22-3.22-1.44-3.22-3.22-3.22Zm0,4.84c-.89,0-1.62-.73-1.62-1.62s.73-1.62,1.62-1.62,1.62.73,1.62,1.62-.73,1.62-1.62,1.62Z",
    fill: "#75e8f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.56d447f6e3dd8212c9a8d1a4378096ce.svg";
export { ForwardRef as ReactComponent };